import React from 'react';
import { FileText, BarChart, Calendar, Download } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Reports feature
 * Displays information about the Reports feature and its benefits
 */
export const ReportsFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Security Reports"
      description="Generate comprehensive security reports with detailed insights, metrics, and recommendations to track your security posture over time."
      icon={<FileText className="h-8 w-8 text-blue-600" />}
      featureName="reports"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <BarChart className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Security Metrics</h3>
          </div>
          <p className="text-gray-400">
            Track key security metrics and KPIs with detailed visualizations and trend analysis to measure your security posture.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Calendar className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Scheduled Reports</h3>
          </div>
          <p className="text-gray-400">
            Set up automated report generation and delivery on daily, weekly, or monthly schedules for consistent monitoring.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <FileText className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Executive Summaries</h3>
          </div>
          <p className="text-gray-400">
            Generate executive-level security summaries with high-level insights and recommendations for leadership teams.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Download className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Export Options</h3>
          </div>
          <p className="text-gray-400">
            Export reports in multiple formats including PDF, CSV, and interactive dashboards for sharing and presentation.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
